import { type Dispatch, type SetStateAction, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Button from "@/components/Button";
import { Popover, PopoverContent, PopoverTrigger } from "@/utils/popover";
import "./DropDown.scss";
import { ChevronDown } from "react-bootstrap-icons";

interface Props {
  id?: string;
  text?: string;
  itemsList?: DropDownItem[];
  activeFilter: string[];
  updateFilter: Dispatch<SetStateAction<string[]>>;
  btnStyle?: React.CSSProperties;
}

export interface DropDownItem {
  default?: boolean;
  id: string | null;
  name: string;
}

export function DropDownFilterList(props: Props) {
  const { itemsList, activeFilter, updateFilter, btnStyle } = props;
  const [search, setSearch] = useState<string>("");
  const [toShow, setToShow] = useState<DropDownItem[]>([]);

  useEffect(() => {
    const toSet =
      itemsList?.filter((i) =>
        i.name.toLowerCase().includes(search.toLowerCase()),
      ) ?? [];
    setToShow(toSet);
  }, [itemsList, search]);

  const clearFilters = () => {
    updateFilter([]);
    setSearch("");
  };

  return (
    <Popover placement="bottom-start" modal={true}>
      <PopoverTrigger
        style={{
          border: "none",
          background: "none",
          padding: 0,
          paddingRight: "8px",
        }}
      >
        <div
          className="btn btn-outline-primary btn-sm popper-btn-custom"
          style={btnStyle ?? { maxHeight: "26px", fontSize: "12px" }}
        >
          {props.text}&nbsp;
          <ChevronDown />
        </div>
      </PopoverTrigger>
      <PopoverContent>
        <div className="popper-filter-dropdown" style={{ width: "230px" }}>
          <Form.Control
            className="mb-3"
            placeholder="Type to search..."
            onChange={(e) => setSearch(e.target.value)}
            value={search}
          />
          <ul
            className="list-unstyled"
            style={{ overflow: "auto", maxHeight: "230px" }}
          >
            {toShow && toShow.length > 0
              ? toShow?.map((item) => (
                  // biome-ignore lint/a11y/useKeyWithClickEvents: TODO: replace with button
                  <li
                    key={item?.id ? item.name : Math.random()}
                    onClick={() => {
                      const idx = activeFilter.find((it) => it === item.id);
                      if (idx === undefined) {
                        updateFilter([...activeFilter, item.id ?? ""]);
                      } else {
                        updateFilter(
                          activeFilter.filter((fi) => fi !== item.id),
                        );
                      }
                    }}
                  >
                    <Form.Check
                      className="form-check-no-shadow"
                      type="checkbox"
                      readOnly={true}
                      checked={activeFilter.some(
                        (filter) => filter === item.id,
                      )}
                      label={item?.name}
                    />
                  </li>
                ))
              : "No results found."}
          </ul>
          <div style={{ display: "flex" }}>
            <div style={{ flex: 1, alignContent: "flex-start" }}>
              <Button variant="default" size="sm" onClick={clearFilters}>
                Clear
              </Button>
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
